"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArcForm = ArcForm;
Object.defineProperty(exports, "Form", {
  enumerable: true,
  get: function get() {
    return _lib.Form;
  }
});
var _react = _interopRequireWildcard(require("react"));
var _lib = require("../lib");
var _formsModule = _interopRequireDefault(require("./forms.module.scss"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ArcForm(props) {
  var ref = (0, _react.useRef)();
  var fields = props.fields,
    formName = props.formName,
    onFinish = props.onFinish,
    form = props.form,
    onPressEnter = props.onPressEnter,
    initialValues = props.initialValues,
    disabled = props.disabled,
    onFieldsChange = props.onFieldsChange,
    onFinishFailed = props.onFinishFailed,
    onValuesChange = props.onValuesChange,
    key = props.key;
  function getData(data, fields) {
    var finalData = '';
    for (var index = 0; index < fields.length; index++) {
      if (!finalData) finalData = data[fields[index]];else finalData = finalData[fields[index]];
    }
    return finalData;
  }
  var handleKeyUp = function handleKeyUp(event) {
    // Enter
    if (event.keyCode === 13 && onPressEnter) {
      ref.current.submit();
    }
  };
  (0, _react.useEffect)(function () {
    if (onPressEnter) {
      window.addEventListener("keyup", handleKeyUp);
      return function () {
        window.removeEventListener("keyup", handleKeyUp);
      };
    }
  }, []);
  (0, _react.useEffect)(function () {
    console.log("formval", initialValues);
  }, [initialValues]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_lib.Form, {
    layout: 'vertical',
    form: form,
    ref: ref,
    name: formName,
    initialValues: initialValues,
    onValuesChange: onValuesChange,
    onFinishFailed: onFinishFailed,
    onFinish: onFinish,
    onFieldsChange: onFieldsChange,
    autoComplete: "off",
    disabled: disabled,
    key: key
  }, fields.map(function (field, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _formsModule["default"].wrapper,
      key: "".concat(field.name, "_").concat(index)
    }, field.type === 'text' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, _extends({
      name: field.name,
      label: field.label,
      rules: field.rules
    }, field), /*#__PURE__*/_react["default"].createElement(_index.ArcInput, field)), field.type === 'password' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, _extends({
      name: field.name,
      label: field.label,
      rules: field.rules
    }, field), /*#__PURE__*/_react["default"].createElement(_index.ArcInput, field)), field.type === 'email' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.label,
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcInput, field)), field.type === 'radio' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.label,
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcRadio, _extends({}, field, {
      displayKey: field.displayKey,
      options: field.options
    }))), field.type === 'checkbox' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.display ? field.display : '',
      valuePropName: "checked",
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcCheckbox, field)), field.type === 'switch' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.label,
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcSwitch, _extends({}, field, {
      defaultChecked: initialValues ? Array.isArray(field.name) ? getData(initialValues, field.name) : initialValues[field === null || field === void 0 ? void 0 : field.name] : ''
    }))), field.type === 'date' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.label,
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcDate, field)), field.type === 'time' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.label,
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcTime, field)), field.type === 'textarea' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.label,
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcTextArea, field)), field.type === 'autocomplete' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.label,
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcAutoComplete, field)), field.type === 'upload' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.label,
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcFileUpload, field)), field.type === 'number' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, _extends({
      name: field.name,
      label: field.label
    }, field, {
      rules: field.rules
    }), /*#__PURE__*/_react["default"].createElement(_index.ArcInputNumber, null)), field.type === 'ratings' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.label,
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcRatings, field)), field.type === 'slider' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.label,
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcSlider, field)), field.type === 'multiselect' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.label,
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcMultiSelect, _extends({}, field, {
      displayKey: field.displayKey,
      defaultValue: initialValues && initialValues[field.name],
      options: field.options
    }))), field.type === 'singleselect' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.label,
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcSingleSelect, _extends({}, field, {
      displayKey: field.displayKey,
      defaultValue: initialValues && initialValues[field === null || field === void 0 ? void 0 : field.name],
      options: field.options
    }))), field.type === 'select' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.label,
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcSelect, field)), field.type === 'tagselect' && /*#__PURE__*/_react["default"].createElement(_lib.Form.Item, {
      name: field.name,
      label: field.label,
      rules: field.rules
    }, /*#__PURE__*/_react["default"].createElement(_index.ArcTagSelect, _extends({}, field, {
      displayKey: field.label,
      defaultValue: initialValues ? Array.isArray(field.name) ? getData(initialValues, field.name) : initialValues[field === null || field === void 0 ? void 0 : field.name] : '',
      options: field.options
    }))));
  })));
}